import { useCapitalGlobalProposalStep1Form } from '@/features/proposals/components/capital-global/steps/capital-global-proposal-step1-form.context';
import {
  capitalGlobalEffectiveStartDateWindowMessage,
  isAfterCapitalGlobalEffectiveWindow,
} from '@/features/proposals/components/capital-global/utils/capital-global-effective-date-window.util';
import { Text } from '@noorden-insurtech/alba-design-system';
import { DateTime } from 'luxon';

export function CapitalGlobalProposalQuotationDataSection() {
  const { form, isViewMode, minDate, maxDate, shouldShowStep1FieldErrors } =
    useCapitalGlobalProposalStep1Form();

  return (
    <div className='flex flex-col gap-6'>
      <Text className='text-base font-normal text-alba-black-500'>
        Dados da Cotação
      </Text>
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
        <form.AppField
          name='effectiveStartDate'
          validators={{
            onChange: ({ value, fieldApi }) => {
              if (isViewMode) return undefined;
              // Teto comercial dos 30 dias: bloqueia assim que a data é
              // escolhida, sem esperar a tentativa de envio.
              if (isAfterCapitalGlobalEffectiveWindow(value))
                return capitalGlobalEffectiveStartDateWindowMessage();
              if (!shouldShowStep1FieldErrors(fieldApi)) return undefined;
              if (!value) return 'Início da vigência é obrigatório';
              if (DateTime.fromISO(value) < DateTime.fromISO(minDate))
                return 'A data de início deve ser a partir de hoje';
              return undefined;
            },
          }}
          children={field => (
            <field.CalendarField
              label='Início da Vigência'
              placeholder='Selecione a data'
              required
              minDate={minDate}
              maxDate={maxDate}
              disabled={isViewMode}
            />
          )}
        />
      </div>
    </div>
  );
}
